"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasisTheoryProxy = require("./BasisTheoryProxy");

Object.keys(_BasisTheoryProxy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BasisTheoryProxy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasisTheoryProxy[key];
    }
  });
});